<!-- eslint-disable vue/multi-word-component-names, vue/no-reserved-component-names, vue/no-v-html, vue/no-v-text-v-html-on-component -->
<template>
	<component :is="tag" v-if="html" v-html="value" />
	<component :is="tag" v-else>{{ value }}</component>
</template>

<script>
/* eslint-disable vue/multi-word-component-names, vue/no-reserved-component-names */
import { computed } from "vue"
import { t, lang } from "@/config/i18n"

export default {
	name: "Text",
	props: {
		path: { type: String, required: true },
		tag: { type: String, default: "span" },
		html: { type: Boolean, default: false },
	},
	setup(props) {
		const value = computed(() => {
			void lang.value
			return t(props.path)
		})
		return { value }
	},
}
</script>
